import createReactContext from '@ant-design/create-react-context';
var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;
//# sourceMappingURL=context.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/context.js
// module id = 638
// module chunks = 0